<template>
  <div style="padding:20px;">
    
    <h1>GlooPay</h1>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
   
  }
}
</script>
 